import { CalendarEvent } from '../api/types';

// Exchange adds forwarded invitations asynchronously, so refetch until the backend reports the user as an attendee.
export const PENDING_INVITATION_REFETCH_INTERVAL_MS = 5000;

export function hasPendingInvitation(
  data: CalendarEvent | CalendarEvent[] | null | undefined,
): boolean {
  const events = Array.isArray(data) ? data : [data];
  return events.some(event => event?.isInvitationPending);
}
